import { AccessMenu, Account, OTP, OTP2FA, ProfileMfaOtpResponse, Token, Token2FA, Token2FAEnrollment, TwoFactorAuthLogin } from '@/domain/entities/Account'
import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './BaseMapper'

export class AuthDataMapper extends BaseResponseMapper {
  public convertAuthFromApi(result: AxiosResponse<any>): Token {
    const { data } = result
    return new Token({
      accessToken: data.token,
      expiredAt: Number(data.expired_at),
      requireChangePassword: data.require_change_password,
    })
  }

  public convertMyProfileFromApi(result: AxiosResponse<any>): Account {
    const { data } = result
    return new Account(
      data.account_id,
      data.email,
      data.role,
      undefined,
      data.access_menu.map(
        (menu: Record<string, any>) =>
          new AccessMenu(menu.id, menu.slug, menu.name, menu.group, true)
      ),
      data.is_login_2fa_enabled,
      data.is_login_2fa_enrolled
    )
  }

  public convertRequestLibertaOTPFromApi(result: AxiosResponse<any>): OTP {
    const { data } = result
    return new OTP({
      email: data.email,
      otpId: data.otp_id,
      expiredIn: data.expired_in
    })
  }

  public convertAuth2FAFromApi(result: AxiosResponse<any>) {
    const { data: { authentication, two_factor_authentication } } = result

    return new TwoFactorAuthLogin({
      authentication: new Token({
        accessToken: authentication?.token,
        expiredAt: Number(authentication?.expired_at),
        requireChangePassword: authentication?.require_change_password,
      }),
      twoFactorAuth: new Token2FA({
        challengeToken: two_factor_authentication?.challenge_token,
        expiresAt: two_factor_authentication?.expires_at,
        otpRequired: two_factor_authentication?.otp_required,
        enrollment: new Token2FAEnrollment({
          enrolled: two_factor_authentication?.enrollment?.enrolled,
          setupRequired: two_factor_authentication?.enrollment?.setup_required
        })
      })
    })
  }

  public convertRequestOTP2FAFromApi(result: AxiosResponse<any>) {
    const { data } = result;

    return new OTP2FA({
      cooldownIn: data.cooldown_in,
      expiredAt: data.expired_at,
      expiredIn: data.expired_in,
      otpId: data.otp_id,
      username: data.username
    });
  }
    
  public convertProfileMfaOtpFromApi(
    result: AxiosResponse<any>
  ): ProfileMfaOtpResponse {
    const { data } = result

    return {
      otpId: data.otp_id,
      username: data.username,
      expiredIn: data.expired_in,
      cooldownIn: data.cooldown_in,
      expiredAt: data.expired_at,
    }
  }

  public convertProfileMfaVerifyFromApi(
    result: AxiosResponse<any>
  ): boolean {
    return result.data.is_login_2fa_enrolled
  }
}
